import { type RefObject } from "react";

import { useEventListener } from "./useEventListener";

type Handler = (event: MouseEvent) => void;

export function useOnClickOutside(
  refs: RefObject<any> | Array<RefObject<any> | undefined>,
  handler: Handler,
): void {
  useEventListener("mousedown", (event) => {
    // Do nothing if clicking ref's element or descendent elements

    if (
      (Array.isArray(refs) ? refs : [refs]).some((ref) => {
        if (ref === undefined) return false;
        const el = ref?.current;

        if (!el || el.contains(event.target as Node)) {
          return true;
        }
      })
    ) {
      return;
    }

    handler(event);
  });
}
